import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[medsurf-design-content-input-group]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './input-group.content.design.html',
    styleUrls: ['./input-group.content.design.scss'],
    host: { class: 'flex' },
    standalone: false
})
export class InputGroupContentDesign {
}
